import script from "./numberComponentViewColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./numberComponentViewColumn.vue?vue&type=script&setup=true&lang=js"

import "./numberComponentViewColumn.vue?vue&type=style&index=0&id=7c53c0af&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c53c0af"]])

export default __exports__